import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'
	
export default {
	session(): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/login/session`, null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	login(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/login/login`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	logout(): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/login/logout`, null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	forgotPassword(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/login/password/forgot`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	resetPassword(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/login/password/reset`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	checkAuthEnrollStatus(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost('login/checkAuthEnrollStatus', request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				})
		})
	},
	sendPushAuth(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost('login/sendPushAuth', request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				})
		})
	},
	refreshSession(): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost('login/refreshSession', null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				})
		})
	}
}
